import script from "./TournamentFanbase.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentFanbase.vue?vue&type=script&setup=true&lang=js"

import "./fanbase.css?vue&type=style&index=0&id=34cfb5d4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cfb5d4"]])

export default __exports__